module.exports = __webpack_public_path__ + "img/small.268b0d87.jpg";